import { EAppActions } from "./types";
/* -------------------------------------------------------------------------------------------------
 * App
 * -----------------------------------------------------------------------------------------------*/
const setErrorReportingEnabled = (errorReportingEnabled, dispatch) => dispatch({ type: EAppActions.SET_ERROR_REPORTING_ENABLED, payload: { errorReportingEnabled } });
const setConnectWalletOpen = (walletConnectOpen, dispatch) => dispatch({ type: EAppActions.CONNECT_WALLET_OPEN, payload: { walletConnectOpen } });
const setOffCanvasOpen = (offCanvasOpen, dispatch) => dispatch({ type: EAppActions.SET_OFFCANVAS_OPEN, payload: { offCanvasOpen } });
const setNetworkOpen = (networkOpen, dispatch) => dispatch({ type: EAppActions.SET_NETWORK_OPEN, payload: { networkOpen } });
/* -------------------------------------------------------------------------------------------------
 * Exchange
 * -----------------------------------------------------------------------------------------------*/
const setAssetSelectContext = (assetSelectContext, dispatch) => dispatch({
    type: EAppActions.SET_ASSET_SELECT_CONTEXT,
    payload: {
        assetSelectContext,
    },
});
const setAssetSelectOpen = (assetSelectOpen, dispatch) => dispatch({
    type: EAppActions.SET_ASSET_SELECT_OPEN,
    payload: { assetSelectOpen },
});
const setExchangeInputValue = (inputValue, dispatch) => dispatch({
    type: EAppActions.SET_EXCHANGE_INPUT_VALUE,
    payload: { inputValue },
});
const setExchangeOutputValue = (outputValue, dispatch) => dispatch({
    type: EAppActions.SET_EXCHANGE_OUTPUT_VALUE,
    payload: { outputValue },
});
/* -------------------------------------------------------------------------------------------------
 * Export
 * -----------------------------------------------------------------------------------------------*/
export const Actions = {
    setAssetSelectContext,
    setAssetSelectOpen,
    setErrorReportingEnabled,
    setConnectWalletOpen,
    setExchangeInputValue,
    setExchangeOutputValue,
    setOffCanvasOpen,
    setNetworkOpen,
};
//# sourceMappingURL=actions.js.map